import { DrawerComponent } from "@/components";
import { AddressModule, Stages } from "@/components/Address";

export const WorkAddressDrawer = ({
  fieldName,
  handleDrawer,
  open,
  handleOnSubmit,
}) => {
  return (
    <DrawerComponent handleDrawer={handleDrawer} open={open}>
      <AddressModule>
        <AddressModule.Container start = {Stages.map}>
          {/* <AddressModule.Content
            keyName={Stages.location}
            component={
              <AddressModule.AddressAutosuggestion
                nextStage={Stages.map}
                fieldName={fieldName}
              />
            }
          /> */}
          <AddressModule.Content
            keyName={Stages.map}
            component={<AddressModule.Map  autosuggestion/>}
          />
          <AddressModule.Content
            keyName={Stages.addressFields}
            component={
              <AddressModule.AddressFields
                resetStateOnSubmit={false}
                fieldLabels={{
                  line2: "Tower/Apartment/Building",
                  line3: "Street/Locality/Area",
                  landmark: "Landmark",
                }}
                handleOnSubmit={handleOnSubmit}
              />
            }
          />
        </AddressModule.Container>
      </AddressModule>
    </DrawerComponent>
  );
};
